import { useQuery } from "@tanstack/react-query";
import {
  getAllProducts,
  getChildrenById,
  getMacrocategories,
  getProdottoById,
} from "../../service";
import { ProductDetail } from "../../utils/interfaces";

function useGetAllProducts() {
  return useQuery({
    queryKey: ["products"],
    queryFn: () => getAllProducts(),
  });
}
function useGetAllMacros() {
  return useQuery({
    queryKey: ["macros"],
    queryFn: () => getMacrocategories(),
  });
}

type PropsCat = {
  id: string;
  enabledFn?: boolean;
};

function useGetCategoriesById({ id, enabledFn }: PropsCat) {
  return useQuery({
    queryKey: ["categories", id],
    queryFn: () => getChildrenById(id),
    enabled: enabledFn,
    staleTime: 3 * 60 * 1000,
  });
}

type PropsSubCat = {
  id: string;
  enabledFn?: boolean;
};
function useGetSubcategoriesById({ id, enabledFn }: PropsSubCat) {
  return useQuery({
    queryKey: ["subcategories", id],
    queryFn: () => getChildrenById(id),
    enabled: enabledFn,
    staleTime: 3 * 60 * 1000,
  });
}

type PropsProducts = {
  id: string;
  enabledFn?: boolean;
};
function useGetProductsById({ id, enabledFn }: PropsProducts) {
  return useQuery({
    queryKey: ["products", id],
    queryFn: () => getChildrenById(id),
    enabled: enabledFn,
    staleTime: 3 * 60 * 1000,
  });
}

type PropsDetails = {
  id: string;
  enabledFn?: boolean;
};

function useGetProductsDetailsById({ id, enabledFn }: PropsDetails) {
  return useQuery<ProductDetail, Error>({
    queryKey: ["product", id],
    queryFn: () => getProdottoById(id),
    enabled: enabledFn,
    staleTime: 3 * 60 * 1000,
  });
}

export {
  useGetAllProducts,
  useGetAllMacros,
  useGetCategoriesById,
  useGetProductsById,
  useGetSubcategoriesById,
  useGetProductsDetailsById,
};
